<div cdkDrag [cdkDragDisabled]="!modalDragOn" cdkDragRootElement=".modal-content" class="logs-modal">
<!-- <div class="modal-content logs-modal"> -->
  <div style="background-color: #548235;  height: 7px;"></div>
  <div class="modal-header" (mouseenter)="setDragOn(true)" (mouseleave)="setDragOn(false)" style="background-color:#a9d18e; height: 50px; padding-top: 20px; border-radius: 0px;">
    <h5 style="color: rgb(10, 10, 10); text-transform: none;">Triggered Event Actions for {{event.name}}</h5>
    <!-- <button (click)="evaluateAndInvokeModalRef.hide()" aria-label="Close" class="close pull-right" type="button"><span
      aria-hidden="true">&times;</span></button> -->
    <button
      (click)="bsModalRef.hide()"
      class="ms-auto fas fa-times"pe="button"
      style="background-color: transparent; border: transparent; font-size: 16px; margin-top: -4px;;">
    </button>
  </div>

  <div class="modal-body">
    <p-table [columns]="eventInvokeResultsCols" [value]="actionResults" >
      <ng-template let-columns pTemplate="header">
        <tr>
          <th *ngFor="let col of columns" [pSortableColumn]="col.field" class="text-center" style="background-color: var(--kig-section-header-bg);">
            {{col.header}}
            <p-sortIcon *ngIf="col.header!=''" [field]="col.field"></p-sortIcon>
          </th>
        </tr>
      </ng-template>
      <ng-template let-columns="columns" let-rowData pTemplate="body">
        <tr>
          <td class="text-center">
            {{rowData.type}}
          </td>
          <td class="text-center">
            {{rowData.details}}
          </td>
          <td class="text-center">
            {{rowData.message}}
          </td>

        </tr>
      </ng-template>
    </p-table>
  </div>
</div>
